import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as fromComponents from './components';

import { PatientCartsRoutingModule } from './patient-carts-routing.module';
import { PatientCartsComponent } from './patient-carts.component';
import { SharedModule } from '@app/shared/shared.module';
import { CoreModule } from '@app/core/core.module';

@NgModule({
  declarations: [PatientCartsComponent, ...fromComponents.components],
  imports: [CommonModule, PatientCartsRoutingModule, SharedModule],
})
export class PatientCartsModule {}
